/* eslint-disable */
import API from '@/api/index'
import CryptoJS from 'crypto-js'
export default{//全局方法
    analysisTime:(time,type)=>{
        //type  :  0 年月日时分秒   1年月日  2时分秒
        function doubleTime(num) {
			if(num < 10) {
				return '0' + num;
			} else {
				return num;
			}
		};
		if (typeof time === 'string') {
			time = time.replace(/-/g,'/')
		}
		time = new Date(time);
        let y = time.getFullYear(),
            mo = doubleTime(time.getMonth()+1),
            d = doubleTime(time.getDate()),
            h = doubleTime(time.getHours()),
            mi = doubleTime(time.getMinutes()),
            s = doubleTime(time.getSeconds());
        if(type == 0){
            return y + "-" + mo + "-" + d + " " + h + ":" + mi + ":" + s; 
        }else if(type == 1){
            return y + "-" + mo + "-" + d ; 
        }else if(type == 2){
            return  h + ":" + mi + ":" + s; 
        }else if(type == 3){
            return y + "年" + mo + "月" + d + "日";
        }else if(type == 4){
            return y + "" + mo + "" + d + "";
        }else if(type == 5){
            return y + "年" + mo + "月" + d + "日" + " " + h + ":" + mi;
        }
    },
    		/* 获取当前时间 */
	getTime: ()=> {
		var str;
		var SArray = new Array("日", "一", "二", "三", "四", "五", "六");

		function doubleTime(num) {
			if(num < 10) {
				return '0' + num;
			} else {
				return num;
			}
		}
		var nTime = new Date();
		// 程序计时的月从0开始取值后+1
		var day = nTime.getDay();
		var year = doubleTime(nTime.getFullYear());
		var mon = doubleTime(nTime.getMonth() + 1);
		var todate = doubleTime(nTime.getDate());
		str = year + "年" + mon + "月" + todate + "日 ";
		str += "星期" + SArray[day];
		return str;
	},
	getTime2: function(type) {
		function doubleTime(num) {
			if(num < 10) {
				return '0' + num;
			} else {
				return num;
			}
		}
		var nTime = new Date();
		// 程序计时的月从0开始取值后+1
		var day = nTime.getDay();
		var year = doubleTime(nTime.getFullYear());
		var mon = doubleTime(nTime.getMonth() + 1);
		var todate = doubleTime(nTime.getDate());
		var hour = doubleTime(nTime.getHours());
		var min = doubleTime(nTime.getMinutes());
		var sec = doubleTime(nTime.getSeconds());
		/*SDay.innerHTML = "星期" + SArray[day];
		SDate.innerHTML = year + "年" + mon + "月" + todate + "日 ";
		STime.innerHTML = hour + ":" + min + ":" + sec;*/
		if(type == 'day') {
			return year + "-" + mon + "-" + todate;
		}  else if(type == 'year') {
			return year + "年" + mon + "月" + todate + '日 ' + hour + ":" + min;
		} else {
			return year + "-" + mon + "-" + todate + ' ' + hour + ":" + min + ":" + sec;
		}

	},
	getTime3: function(time) {
		var nTime = new Date(time);
		function doubleTime(num) {
			if(num < 10) {
				return '0' + num;
			} else {
				return num;
			}
		}
		// 程序计时的月从0开始取值后+1
		var day = nTime.getDay();
		var year = doubleTime(nTime.getFullYear());
		var mon = doubleTime(nTime.getMonth() + 1);
		var todate = doubleTime(nTime.getDate());
		var hour = doubleTime(nTime.getHours());
		var min = doubleTime(nTime.getMinutes());
		var sec = doubleTime(nTime.getSeconds());
		return year + "-" + mon + "-" + todate + ' ' + hour + ":" + min + ":" + sec;
	},
	getCookie: function(cname) {
		var name = cname + "=";
		var ca = document.cookie.split(';');
		for(var i = 0; i < ca.length; i++) {
			var c = ca[i].trim();
			if(c.indexOf(name) == 0) return c.substring(name.length, c.length);
		}
		return "";
	},
	/* 设置cookie */
	setCookie: function(cname) {
		var name = this.getCookie(cname);
		if(name != '') {
			return name;
			//			location.href = 'index.html';
		} else {
			// this.$router.push('/')
			location.href = '/'
		}
	},
	/* 删除cookie------ user=admin  key1=user  */
	delCookie: function(key) {
		var newkey = this.getCookie(key1);
		var ckey = key + '=' + newkey + ";";
		var day = 'Thu, 01 Jan 1970 00:00:00 GMT';
		document.cookie = ckey + 'path=/;expires= ' + day;
	},
	/* 判断是否为------ user=admin  key1=user  */
	isNumber: function(val){
	    var regPos = /^\d+(\.\d+)?$/; //非负浮点数
	    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
	    if(regPos.test(val) || regNeg.test(val)){
	        return true;
	    }else{
	        return false;
	    }
	},
	/* 转换百分号% */
	changeNum: function(num){
		num = (Number(num)*100).toFixed(2)
		return Number(num).toFixed(2)
	},
	/* 跳转页面 */
	changeURL: function(str){
		var app = window.navigator.appVersion.toLocaleLowerCase();
		if (app.indexOf("windows phone") > 0) {
			window.external.notify(str);
		} else if (app.indexOf("iphone") > 0) {
			window.location.href = str;
		} else if (app.indexOf("android") > 0) {
			try{
				window.MyWebView.onJsOverrideUrlLoading(str);
			}catch(e){
				window.location.href = str;
			}
		} else {
			window.location.href = str;
		}
	},
	/* 字符串yyyymmdd转日期格式yyyy-mm-dd */
	ToyyyyMMdd: function(setDate){
		if (setDate) {
			let valDate = ''
		    if (setDate.length === 8) {
		        valDate = setDate.substring(0, 4) + '-' + setDate.substring(4, 6) + '-' + setDate.substring(6, 8)
		       	return valDate
		    } else if (setDate.length === 6) {
		        valDate = setDate.substring(0, 4) + '-' + setDate.substring(4, 6)
		        return valDate
		    }
		    return valDate
		}
	},
	/* 字符串yyyy-mm-dd转日期格式yyyy-Q4 */
	ToQQQtime: function(time){
		if(time){
			let oldstr = time.substring(5, 10)
			let newstr = time.substring(0, 5)
			switch(oldstr) {
				case '12-31': newstr = newstr + 'Q4'; break;
				case '09-30': newstr = newstr + 'Q3'; break;
				case '06-30': newstr = newstr + 'Q2'; break;
				case '03-31': newstr = newstr + 'Q1'; break;
			}
			return  newstr
		}
	},
	/* 对比大小 */
	compare: function (prop) {
		return function (oldobj, newobj) {
	        let oldval = oldobj[prop]
	        let newval = newobj[prop]
	        if (!isNaN(Number(oldval)) && !isNaN(Number(newval))) {
	            oldval = Number(oldval)
	            newval = Number(newval)
	        }
	        if (oldval < newval) {
	            return 1
	        } else if (oldval > newval) {
	            return -1
	        } else {
	            return 0
	        }
	    }
	},
	/* 从大到小排序  */
	contrast: function (arr, index) {
		arr.sort(this.compare(index))
	},
	/* 滚动距离  */
	getScrollTop: function (){
	　　var scrollTop = 0, bodyScrollTop = 0, documentScrollTop = 0;
	　　if(document.body){
	　　　　bodyScrollTop = document.body.scrollTop;
	　　}
	　　if(document.documentElement){
	　　　　documentScrollTop = document.documentElement.scrollTop;
	　　}
	　　scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
	　　return scrollTop;
	},
	/* 文档的总高度  */
	getScrollHeight: function (){
	　　var scrollHeight = 0, bodyScrollHeight = 0, documentScrollHeight = 0;
	　　if(document.body){
	　　　　bodyScrollHeight = document.body.scrollHeight;
	　　}
	　　if(document.documentElement){
	　　　　documentScrollHeight = document.documentElement.scrollHeight;
	　　}
	　　scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight;
	　　return scrollHeight;
	},
	/* 浏览器视口的高度  */
	getWindowHeight: function (){
	　　var windowHeight = 0;
	　　if(document.compatMode == "CSS1Compat"){
	　　　　windowHeight = document.documentElement.clientHeight;
	　　}else{
	　　　　windowHeight = document.body.clientHeight;
	　　}
	　　return windowHeight;
	},
	/* 获取智富通信息  */
	getzftData: function(fun) {
		let appData = {}
		window.zftGetLocalConstFromApp = function(data) {
			if (typeof data === 'object') {
				appData = data
			} else {
				appData = JSON.parse(data)
			}
			fun && fun(appData)
		}
		let isZFT = /(efortune)/i.test(window.navigator.userAgent)
		if (isZFT) { // 获取智富通登陆信息
			let app = window.navigator.appVersion.toLocaleLowerCase()
			const keyMap = ['accounttype=0', 'appname', 'jyloginflag', 'mobilecode', 'account', 'password', 'softversion',
				'devicemodel', 'tztudid', 'phoneve', 'usercode'
			]
			if (app.indexOf('iphone') > 0) {
				try {
					window.webkit.messageHandlers.zftCallLocalConstFromApp.postMessage(keyMap)
				} catch (e) {
					window.zftCallLocalConstFromApp('reqlocal', keyMap, 'zftGetLocalConstFromApp')
				}
			} else if (app.indexOf('android') > 0) {
				appData = JSON.parse(window.LocalFunction.getLocalVal(keyMap))
				fun && fun(appData)
			}
		} else {
			fun && fun(appData)
		}
	},
	/* 改变标题  */
	changeTitle: function (str) {
		let isZFT = /(efortune)/i.test(window.navigator.userAgent)
		document.title = str
		if (isZFT) {
			this.changeURL('http://action:8809/?title=' + str)
		}
	},
	/* 将表情转为字符  */
	utf16toEntities: function (str) { 
	    var patt=/[\ud800-\udbff][\udc00-\udfff]/g; // 检测utf16字符正则 
	    str = str.replace(patt, function(char){ 
	        var H, L, code; 
	        if (char.length===2) { 
	            H = char.charCodeAt(0); // 取出高位 
	            L = char.charCodeAt(1); // 取出低位 
	            code = (H - 0xD800) * 0x400 + 0x10000 + L - 0xDC00; // 转换算法 
	            return "&#" + code + ";"; 
	        } else { 
	            return char; 
	        } 
	    }); 
	    return str; 
	},
	/* 将字符转为表情  */
	uncodeUtf16: function (str) {
	    var reg = /\&#.*?;/g;
	    var result = str.replace(reg,function(char){
	        var H,L,code;
	        if(char.length == 9 ){
	            code = parseInt(char.match(/[0-9]+/g));
	            H = Math.floor((code-0x10000) / 0x400)+0xD800;
	            L = (code - 0x10000) % 0x400 + 0xDC00;
	            return unescape("%u"+H.toString(16)+"%u"+L.toString(16));
	        }else{
	            return char;
	        }
	    });
	    return result;
	},
	/* APP嵌套H5埋点  */
	onEvent (params, other) {
		try {
			let new_params = {
				page_name: params.page_name || params.id,
				page_title: params.page_title || API.serviceName + '-' + params.params.channel,
				serviceName: API.serviceName,
				serviceId: API.serviceId,
				function: params.params.channel,
				functionId: params.id
			}
			if (typeof other === 'object') {
				new_params = Object.assign(other, new_params)
			}
			aplus_queue.push({
			  action: 'aplus.record',
			  arguments: [params.id, 'CLK',
			    Object.assign({
			      //必传参数
			      ts: new Date().getTime(), //当前时间戳
			    }, new_params),
			  ],
			});
		} catch (e) {}
	},
	/* 时区转换，判断是否在交易时间  */
	tradeTime (starTime = 570, endTime = 900) {
		var date = new Date()
		var localTime = date.getTime() // 当前时区时间
		var localOffset = date.getTimezoneOffset() * 60000 // 获取当前时区与标准时区分钟差，UTC时间
		var utc = localTime + localOffset // 得到UTC时间
		var offset = 8; //以中国时间为例，东8区
		var ChinaTime = utc + (3600000 * offset) // 计算得到东8区时间
		var nd = new Date(ChinaTime)
		var now = nd.getHours()*60 + nd.getMinutes() // 当前时间
		//不在交易时间范围 早于9:30||晚于15:00
		if(now<starTime || now>endTime){
			return false
		}else{
			return true
		}
	},
	/* 获取电脑ip地址 */
	getDeviceIP (clll) {
		function getUserIP (onNewIP) {
			if (!onNewIP) {
				return
			}
		    var myPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
		    var pc = new myPeerConnection({
		        iceServers: []
		    }),
		    noop = function() {},
		    localIPs = {},
		    ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g,
		    key;
		
		    function iterateIP(ip) {
		        if (!localIPs[ip]) onNewIP(ip);
		        localIPs[ip] = true;
		    }
		    pc.createDataChannel("");
		    pc.createOffer().then(function(sdp) {
		        sdp.sdp.split('\n').forEach(function(line) {
		            if (line.indexOf('candidate') < 0) return;
		            line.match(ipRegex).forEach(iterateIP);
		        });
		        pc.setLocalDescription(sdp, noop, noop);
		     })
		     pc.onicecandidate = function(ice) {
		        if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
		        ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
		    };
		}
		getUserIP(clll);
	},
	/*
	 *@notice 兼容新老版本
	 *@params minVersion { string } 最低版本号(包含)；智富通2.0版本号格式5.x.001(android:5.2.001,ios:5.1.001)
	 *@params trueFunc { function } 高于最低版本号(包含)执行方式
	 *@params falseFunc { function } 最低版本号执行方式
	 */
	checkAppVersion (minVersion, trueFunc, falseFunc) {
		let isZFT = /(efortune)/i.test(window.navigator.userAgent)
		if (isZFT) {
			minVersion = minVersion ? minVersion : '5.1.001';
			// 智富通2.0版本号格式android:5.2.001,ios:5.1.001
			var appversion = navigator.appVersion.toLocaleLowerCase();
			if (appversion.indexOf("iphone") > 0) {
				minVersion = minVersion.replace('x', 1)
			} else {
				minVersion = minVersion.replace('x', 2)
			}
			this.getzftData(function (appData) {
				var sThisVersion = appData.softversion
				if (sThisVersion == minVersion) {
					trueFunc && trueFunc();
				} else {
					if (sThisVersion != null || sThisVersion != '' || sThisVersion != 'undefined') {
						var verStrArr = sThisVersion.split("."); // 当前版本
						var minVerStrArr = minVersion.split("."); // 要求版本
						for (var i = 0; i < verStrArr.length; i++) {
							if (parseInt(verStrArr[i]) > parseInt(minVerStrArr[i])) {
								trueFunc && trueFunc();
								return;
							} else if (parseInt(verStrArr[i]) === parseInt(minVerStrArr[i])) {
								continue;
							} else {
								break;
							}
						}
					}
					falseFunc && falseFunc();
				}
			})
		}
	},
	// 跳转行情
	changeStock: function (stockCode,stockType) {
		let isZFT = /(efortune)/i.test(window.navigator.userAgent)
		if (stockCode && isZFT) {
			var _this = this
			var app = navigator.appVersion.toLocaleLowerCase();
			if (app.indexOf('iphone') > 0 || app.indexOf('ipad') > 0) {
				this.checkAppVersion('5.5.0', function(){
					_this.changeURL('http://stock1/?stockCode='+stockCode+'&stockType='+stockType)
				}, function(){
					_this.changeURL('http://stock:'+stockCode)
				})
			} else {
				_this.changeURL('http://stock:'+stockCode)
			}
		}
	},
	/* 通达信数据转换 */
	resultCw(data){
	    var rd = {ErrorCode:0, ErrorInfo:"", tables:[],cols:[]};
	    let d = {}
	    try{
	        d = data
	    }
	    catch(e){
	        d = {ErrorCode: 9001, ErrorInfo:"请求解析失败！"}
	    }
	
	    rd.ErrorCode = d.ErrorCode || 0;
	    rd.ErrorInfo = d.ErrorInfo || "";
	
	    
	    var t = d.ResultSets || [];
	    t.forEach(function (val, valIndex) {
	        var row = [];
	        var cols = val["ColDes"] || val["ColName"] || [];
	        var content = val["Content"] ||[];
	        content.forEach(function(a) {
	            var oneRow = {};
	            cols.forEach(function(b, bIndex) {
	                var colName = b;
	                if (typeof(b) == "string"){
	                    colName = b;
	                }
	                else {
	                    colName = b["Name"]
	                }
	                
	                oneRow[colName] = a[bIndex];
	            }, this);
	            row.push(oneRow);
	        }, this);
	        
	        rd.tables.push(row);
	    });
	    return rd;
	},
	/* 存储信息 */
	setLocalValue (key, value) { // value必须为字符串
		let isZFT = /(efortune)/i.test(window.navigator.userAgent)
		if (isZFT) {
			let app = window.navigator.appVersion.toLocaleLowerCase()
			if (app.indexOf('iphone') > 0 || app.indexOf('ipad') > 0) {
				this.changeURL('http://action:60014/?key=' + key + '&&value=' + value)
			} else if (app.indexOf('android') > 0) {
				window.LocalFunction.putLocalValue(key, value)
			}
		} else {
			localStorage.setItem(key, value)
		}
	},
	/* 读取信息 */
	getLocalValue (key, callBack) {
		let isZFT = /(efortune)/i.test(window.navigator.userAgent)
		window.getLocationInfo = function (value) {
			if (value === '(null)') {
				value = ''
			}
			callBack && callBack(value)
		}
		if (isZFT) {
			let app = window.navigator.appVersion.toLocaleLowerCase()
			if (app.indexOf('iphone') > 0 || app.indexOf('ipad') > 0) {
				this.changeURL('http://action:60015/?key=' + key) // ios调用getLocationInfo方法
			} else if (app.indexOf('android') > 0) {
				var value = window.LocalFunction.getLocalValue(key)
				if (value === '(null)') {
					value = ''
				}
				callBack && callBack(value)
			}
		} else {
			var value = localStorage.getItem(key)
			callBack && callBack(value)
		}
	},
	getZFTHeight (fun) {
		var _this = this
		this.checkAppVersion('5.5.0', function(){
			let isZFT = /(efortune)/i.test(window.navigator.userAgent)
			if (isZFT) {
				window.getHeadHeight = function(num){ // num为物理像素分辨率
					if (num) {
						var newnum = Number(num) / window.devicePixelRatio // 物理像素分辨率与 CSS像素分辨率的比率
						fun && fun(newnum)
					}
				}
				_this.changeURL('http://action:60043/?jsCallback=getHeadHeight')
			}
		})
	},
	tradeTimeZone(func) {
		// 获取当前时间的时区偏移量（分钟）
		var timezoneOffset = new Date().getTimezoneOffset()

		// 东八时区的时区偏移量为-480（即UTC+8）
		var GMT8Offset = -480
		let targetTime = ''

		if(timezoneOffset === GMT8Offset) { // 当前时间在东八时区
			targetTime = this.getTime2('day')
		} else { // 当前时间不在东八时区
			var timezone = 8 // 目标时区时间，东八区
			var offset = new Date().getTimezoneOffset() // 获取当前时间的时区偏移量
			var nowDate = new Date().getTime() // 本地时间距 1970 年 1 月 1 日午夜（GMT 时间）之间的毫秒数
			// 将该新对象的时区设置为东八区（即中国北京时间）
			var targetDate = new Date(nowDate + offset * 60 * 1000 + timezone * 60 * 60 * 1000)
			targetTime = new Date(targetDate).getFullYear() + '-' + ((new Date(targetDate).getMonth() + 1) > 9 ? (new Date(targetDate).getMonth() + 1) : '0' + (new Date(targetDate).getMonth() + 1)) + '-' + (new Date(targetDate).getDate() > 9 ? new Date(targetDate).getDate() : '0' + new Date(targetDate).getDate())
		}
		func && func(targetTime)
	},
	getZfthq(action, paramMap, jsCallback, trueFn, falseFn){
		let isZFT = /(efortune)/i.test(window.navigator.userAgent)
		if (!isZFT) { // 不在智富通
			falseFn && falseFn()
		} else {
			window[jsCallback] = (code, odata) => {
				if (code === '0' || code === 0) {
					odata = decodeURIComponent(odata).replace(/\s*/g, '')
					var parsedWordArray = CryptoJS.enc.Base64.parse(odata)
					var parsedStr = parsedWordArray.toString(CryptoJS.enc.Utf8)
					var res = JSON.parse(parsedStr)
					var oGet = {}
					let app = window.navigator.appVersion.toLocaleLowerCase()
					if (app.indexOf('android') > 0) { // 安卓特殊处理
						for (let i in res) {
							var keys = i.toUpperCase()
							oGet[keys] = res[i]
						}
						oGet.GRID0 = res.Grid.split('\n')
					} else {
						oGet = res
					}
					trueFn && trueFn(oGet)
				}
			}
			let ISGETZFTHQ = localStorage.getItem('ISGETZFTHQ')
			if (ISGETZFTHQ === '0') {
				falseFn && falseFn()
			} else if (ISGETZFTHQ === '1') {
				this.changeURL('http://action:60065/?action='+action+'&&jsCallback='+jsCallback+ '&&paramMap='+JSON.stringify(paramMap))
			} else {
				this.checkAppVersion('7.1.8', () => {
					ISGETZFTHQ = '1'
					localStorage.setItem('ISGETZFTHQ', '1')
					this.changeURL('http://action:60065/?action='+action+'&&jsCallback='+jsCallback+ '&&paramMap='+JSON.stringify(paramMap))
				}, () => {
					ISGETZFTHQ = '0'
					localStorage.setItem('ISGETZFTHQ', '0')
					falseFn && falseFn()
				})
			}
		}
	}
}
/* eslint-enable */


// WEBPACK FOOTER //
// ./src/utils/tool.js